<template>
  <div class="time-picker-custom">
    <v-menu v-model="isActive" offset-y :close-on-content-click="false">
      <template v-slot:activator="{ on }">
        <input
          v-model="time"
          type="text"
          class="form-control timepicker"
          :placeholder="$t('Time')"
          :disabled="disabled"
          solo
          outline
          readonly
          v-on="on"
          hide-details
        />
      </template>
      <div class="time-picker-lists">
        <div class="time-lists">
          <div class="time-list-header">HH</div>
          <div
            class="time-list-item"
            v-for="hour in hours"
            :key="`hour-${hour}`"
            :class="{
              active: hourActive === hour,
              disabled: Number(hour) > maxHour
            }"
            @click="selectHour(hour)"
          >
            {{ hour }}
          </div>
        </div>
        <div class="time-lists">
          <div class="time-list-header">mm</div>
          <div
            class="time-list-item"
            v-for="minute in minutes"
            :key="`minutes-${minute}`"
            :class="{
              active: minuteActive === minute,
              disabled: Number(hourActive) >= maxHour && Number(minute) > maxMinute
            }"
            @click="selectMinute(minute)"
          >
            {{ minute }}
          </div>
        </div>
      </div>
    </v-menu>
  </div>
</template>

<script>
const timeRegex = /^(?:[01]\d|2[0-3]):[0-5]\d$/
export default {
  data: () => ({
    isActive: false
  }),
  props: {
    value: {
      type: String,
      default: () => null
    },
    max: {
      type: String,
      default: () => '24:00'
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    time: {
      get() {
        return this.value ? this.value.slice(0, 5) : ''
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    hours() {
      return Array.from({ length: 25 }, (_, index) => index.toString().padStart('2', '0'))
    },
    minutes() {
      return Array.from({ length: 60 }, (_, index) => index.toString().padStart('2', '0'))
    },
    hourActive() {
      const times = this.value ? this.value.split(':') : []
      return times.length ? times[0] : ''
    },
    minuteActive() {
      const times = this.value ? this.value.split(':') : []
      return times.length > 1 ? times[1] : ''
    },
    maxHour() {
      const times = this.max && timeRegex.test(this.max) ? this.max.split(':') : []
      return this.max === '24:00' ? '24' : times.length ? Number(times[0]) : 0
    },
    maxMinute() {
      const times = this.max && timeRegex.test(this.max) ? this.max.split(':') : []
      return this.max === '24:00' ? '00' : times.length > 1 ? Number(times[1]) : 0
    }
  },
  methods: {
    selectHour(hour) {
      if (hour === '24' || !this.minuteActive) {
        this.$emit('input', `${hour}:00`)
      } else if (Number(this.minuteActive) > this.maxMinute && Number(hour) >= this.maxHour) {
        this.time = `${hour}:00`
      } else {
        this.time = `${hour}:${this.minuteActive}`
      }
    },
    selectMinute(minute) {
      if (minute && !this.hourActive) {
        this.time = `00:${minute}`
      } else if (Number(minute) > this.maxMinute && this.hourActive >= this.maxHour) {
        this.time = `${this.hourActive}:00`
      } else {
        this.time = `${this.hourActive}:${minute}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.time-picker-lists {
  display: flex;
  flex-direction: row;
  padding: 0;
  max-height: 200px;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border: 1px solid #bababa;
  border-radius: 10px;
  outline: none;
  overflow: hidden;
  .time-lists {
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1 1 0;
    height: 100%;
    max-height: 200px;
    overflow-y: auto;

    .time-list-header {
      position: sticky;
      top: 0;
      display: flex;
      justify-content: center;
      min-height: 40px;
      padding: 8px 16px;
      background: #fff;
      color: #a5a5a5;
      font-size: 12px;
    }

    .time-list-item {
      display: flex;
      justify-content: center;
      min-height: 40px;
      padding: 8px 16px;
      background-color: #fff;
      color: #161616;
      cursor: pointer;

      &:hover {
        background-color: rgba(0, 0, 0, 0.08);
      }
      &.active {
        color: #fff;
        background-color: #ed1e79;
      }
      &.disabled {
        color: #a5a5a5;
        cursor: none;
        pointer-events: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/TimePickerCustom.vue